import axiosInstance from "@js-app/services/http/axios-instance";

class _CompaniesApi {
  getCompanies() {
    return axiosInstance.get("/companies", {
      withCredentials: true,
    });
  }

  getCompany(companyId) {
    return axiosInstance.get(`/companies/${companyId}`, {
      withCredentials: true,
    });
  }

  getCompanyDashboard(companyId) {
    return axiosInstance.get(`/companies/${companyId}/dashboard`, {
      withCredentials: true,
    });
  }

  getCompanyAnalytics(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/analytics`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  exportCompanyAnalytics(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/analytics/export`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  exportCompanyBills(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/export`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  getCompanyBills(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/bills`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  createBill(companyId, billData) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/create`,
      {
        ...billData,
      },
      {
        withCredentials: true,
      }
    );
  }

  getBillsSettings(companyId) {
    return axiosInstance.get(`/companies/${companyId}/bills/settings`, {
      withCredentials: true,
    });
  }

  getBill(companyId, billId) {
    return axiosInstance.get(`/companies/${companyId}/bills/${billId}`, {
      withCredentials: true,
    });
  }

  getBillReceipt(companyId, billId) {
    return axiosInstance.get(
      `/companies/${companyId}/bills/${billId}/receipt`,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
  }

  shareBillReceipt(companyId, billId, email) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/${billId}/receipt/share`,
      {
        email,
      },
      {
        withCredentials: true,
      }
    );
  }

  createBillTemplate(companyId, billData) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/templates/create`,
      {
        ...billData,
      },
      {
        withCredentials: true,
      }
    );
  }

  updateBillTemplate(companyId, templateId, billData) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/templates/${templateId}/update`,
      {
        ...billData,
      },
      {
        withCredentials: true,
      }
    );
  }

  getBillsTemplates(companyId) {
    return axiosInstance.get(`/companies/${companyId}/bills/templates`, {
      withCredentials: true,
    });
  }

  getBillTemplate(companyId, templateId) {
    return axiosInstance.get(
      `/companies/${companyId}/bills/templates/${templateId}`,
      {
        withCredentials: true,
      }
    );
  }

  deactivateBillTemplate(companyId, templateId) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/templates/${templateId}/deactivate`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  async makeBillRefund(companyId, billId, sum) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/${billId}/refund`,
      {
        sum,
      },
      {
        withCredentials: true,
      }
    );
  }

  async getRefundCurrencyRate(companyId, operationId) {
    return axiosInstance.get(`/companies/${companyId}/bills/${operationId}/refund/currency-rate`, {
          withCredentials: true,
        }
    )
  }

  async makeOperationRefund(companyId, operationId, sum, terminalId) {
    return axiosInstance.post(
      `/companies/${companyId}/operations/${operationId}/refund`,
      {
        sum,
        terminal_id: terminalId,
      },
      {
        withCredentials: true,
      }
    );
  }

  getCompanyPayoutsToCard(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/to-card`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  exportCompanyPayoutsToCard(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/to-card/export`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  createPayoutToCard(companyId, payoutData) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/to-card/create`,
      {
        payoutData: payoutData,
      },
      {
        withCredentials: true,
      }
    );
  }

  getPayoutToCard(companyId, payoutId) {
    return axiosInstance.get(
      `/companies/${companyId}/payouts/to-card/${payoutId}`,
      {
        withCredentials: true,
      }
    );
  }

  getPayoutsRegistries(companyId, filter = {}) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/list`,
      filter,
      {
        withCredentials: true,
      }
    );
  }

  async getBillsRegistries(companyId, filter = {}) {
    return axiosInstance.post(
      `/companies/${companyId.company_id}/bills/registries`, {
          date_from: filter.date_from,
          date_to: filter.date_to,
        }
    );
  }

  getPayoutsRegistry(companyId, registryId) {
    return axiosInstance.get(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}`,
      {
        withCredentials: true,
      }
    );
  }

  getPayoutsRegistryPositions(companyId, registryId) {
    return axiosInstance.get(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/positions`,
      {
        withCredentials: true,
      }
    );
  }

  getBillsRegistryById(companyId, registryId) {
    console.log("companyId: ", companyId);
    console.log("registryId: ", registryId);
    return axiosInstance.get(
      `/companies/${companyId}/bills/registries/${registryId}`
    );
  }

  getBillsRegistryItemById(companyId, registryId, registryItemId) {
    console.log("companyId: ", companyId);
    console.log("registryId: ", registryId);
    return axiosInstance.get(
      `/companies/${companyId}/bills/registries/${registryId}/${registryItemId}`
    );
  }

  updateRegistryPosition(companyId, registryId, positionData) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/positions/update`,
      positionData,
      {
        withCredentials: true,
      }
    );
  }
  updateRegistry(companyId, registryId, registryData) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/update`,
      registryData,
      {
        withCredentials: true,
      }
    );
  }

  updateBillsRegistry(companyId, registryId, registryData) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/${registryId}/edit`,
      registryData
    );
  }

  deletePayoutsRegistryPosition(companyId, registryId, positionId) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/positions/delete`,
      { id: positionId },
      {
        withCredentials: true,
      }
    );
  }
  repeatPayoutsRegistryItem(companyId, registryId, positionId) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/positions/repeat`,
      { id: positionId },
      {
        withCredentials: true,
      }
    );
  }
  processPayoutsRegistry(companyId, registryId) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/process`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  async processBillsRegistry(companyId, registryId) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/${registryId}/run`
    );
  }

  async loadPayoutsRegistry(companyId, payoutsRegistryFormData) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/create`,
      payoutsRegistryFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  async loadBillsRegistry(companyId, billsRegistryFormData) {
    console.log("billsRegistryFormData: ", billsRegistryFormData);
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/create`,
      billsRegistryFormData
    );
  }

  async updateBillsRegistryById(
    companyId,
    registryId,
    registryItemId,
    positionData
  ) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/${registryId}/${registryItemId}/edit`,
      positionData
    );
  }

  async deleteBillsRegistryById(companyId, registryId, registryItemId) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/${registryId}/${registryItemId}/delete`
    );
  }

  async exportPayoutsRegistry(companyId, registryId) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/export`
    );
  }

  async deletePayoutsRegistry(companyId, registryId) {
    return axiosInstance.post(
      `/companies/${companyId}/payouts/by-registries/registry/${registryId}/delete`
    );
  }

  async deleteBillsRegistry(companyId, registryId) {
    return axiosInstance.post(
      `/companies/${companyId}/bills/registries/${registryId}/delete`
    );
  }

  getOperationDetails(companyId, operationId) {
    return axiosInstance.get(
      `/companies/${companyId}/operations/${operationId}`,
      {
        withCredentials: true,
      }
    );
  }

  getOperationsStatistic(companyId, filters) {
    return axiosInstance.post(
      `/companies/${companyId}/operations/statistic`,
      {
        ...filters,
      },
      {
        withCredentials: true,
      }
    );
  }

  getUsers(companyId) {
    return axiosInstance.get(`/companies/${companyId}/users`, {
      withCredentials: true,
    });
  }

  getCompanyRoles(companyId) {
    return axiosInstance.get(`/companies/${companyId}/roles`, {
      withCredentials: true,
    });
  }

  createCompanyUser(companyId, userData) {
    return axiosInstance.post(
      `/companies/${companyId}/users/create`,
      userData,
      {
        withCredentials: true,
      }
    );
  }

  updateCompanyUserRole(companyId, userData) {
    return axiosInstance.post(
      `/companies/${companyId}/users/update/role`,
      userData,
      {
        withCredentials: true,
      }
    );
  }

  deleteUserFromCompany(companyId, userId) {
    return axiosInstance.post(
      `/companies/${companyId}/users/delete`,
      {
        user_id: userId,
      },
      {
        withCredentials: true,
      }
    );
  }

  async resetCompanyUserPassword(companyId, userId) {
    return axiosInstance.post(
      `/companies/${companyId}/users/reset-password`,
      {
        user_id: userId,
      },
      {
        withCredentials: true,
      }
    );
  }

  async createJiraTicket(companyId, supportFromData) {
    return axiosInstance.post(
      `/companies/${companyId}/support/ticket`,
      supportFromData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  async shareBill(companyId, billData) {
    return await axiosInstance.post(
      `/companies/${companyId}/bills/share`,
      billData
    );
  }

  async shareBillSms(companyId, billData) {
    return await axiosInstance.post(
      `/companies/${companyId}/bills/share/sms`,
      billData
    );
  }
}

export const CompaniesApi = new _CompaniesApi();
